import { initialLearningRecordTabState } from "../_store/learning-record-tab/learning-record-tab.state";
import { initialSkillsCheckState } from "../_store/skills-check-tab/skills-check-tab.state";
import { StoreState } from "../_store/_store.state";
import { initialFormAdministratorState } from "../_store/form-administrator/form-administrator.state";
import { initialLearningPlanState } from "../_store/learning-plan/learning-plan.state";
import { initialSkillsCheckQandAState } from "../_store/skills-check-q-and-a/skills-check-q-and-a.state";
import { initialEditAdministratorState } from "../_store/edit-administrator/edit-administrator.state";
import { initialOrganisationState } from "../_store/organisation/organisation.state";
import { initialCentreState } from "../_store/centre/centre.state";
import { initialNavigationState } from "../_store/navigation/navigation.state";
import { initialGroupState } from "../_store/group/group.state";
import { initialTutorState } from "../_store/tutor/tutor.state";
import { initializeRoleState } from "../_store/role/role.state";
import { initializeUserProfileState } from "../_store/user-profile/user-profile.state";
import { initialCourseState } from "../_store/course/course.state";
import { initialCreateLearnerState } from "../_store/create-learner/create-learner.state";
import { initialLearnerState } from "../_store/learner/learner.state";
import { initialDateProviderState } from "../_store/date-provider/date-provider.state";
import { initialListAdministratorState } from "../_store/list-administrator/list-administrator.state";
import { initialEditLearnerState } from "../_store/edit-learner/edit-learner.state";
import { initialTutorEditState } from "../_store/tutor-edit/tutor-edit.state";
import { initialTutorDeleteState } from "../_store/tutor-delete/tutor-delete.state";
import { initialLearnerCourseState } from "../_store/learner-course/learner-course.state";
import { initialCourseContentMetadataState } from "../_store/course-content-metadata/course-content-metadata.state";
import { initialLearningTrackingState } from "../_store/learning-tracking/learning-tracking.state";
import { initialEditGroupState } from "../_store/edit-group/edit-group.state";
import { initialLearnerOfflineActivityState } from "../_store/learner-offline-activity/learner-offline-activity.state";
import { initialLearningResourceState } from "../_store/learning-resource/learning-resource.state";
import { initialExternalInitialAssessmentState } from "../_store/external-initial-assessment/external-initial-assessment.state";
import { initialAssessmentProfileState } from "../_store/assessment-profile/assessment-profile.state";
import { initialLearnerResourceState } from "../_store/learner-resources/learner-resources.state";
import { initialTransferLearnerState } from "../_store/transfer-learner/transfer-learner.state";
import { initialEventHistoryState } from "../_store/event-history/event-history.state";
import { initialDigLitSelfAssessmentState } from "../_store/dig-lit-self-assessment/dig-lit-self-assessment.state";
import { initialResetMFAState } from "../_store/reset-mfa/reset-mfa.state";
import { initialLearnerReportState } from "../_store/report/learner-report/learner-report.state";
import { initialWrittenAssignmentRecordState } from "../_store/written-assignments-record/written-assignment-record.state";
import { initialImportState } from "../_store/import/import.state";
import { initialImportExternalResultsState } from "../_store/import-external-results/import-external-results.state";
import { initialImportBatchDisableDeleteState } from "../_store/import-batch-disable-delete/import-batch-disable-delete.state";
import { initialAggregateReportState } from "../_store/report/aggregate-report/aggregate-report.state";
import { initialPrintState } from "../_store/print/print.state";

export class StoreConstants {
  static readonly DEFAULT: string = "-";
  static readonly STATE_STORAGE_KEY: string = "_appState_";
  static readonly COURSE_ID: string = "courseId";
  static readonly STATE_LRT: string = "learningRecordTabState";
  static readonly STATE_SCT: string = "skillsCheckTabState";
  static readonly STATE_EA: string = "editAdministratorState";
  static readonly STATE_FA: string = "formAdministratorState";
  static readonly STATE_LP: string = "learningPlanState";
  static readonly STATE_SCQA: string = "skillsCheckQandAState";
  static readonly STATE_OS: string = "organisationState";
  static readonly STATE_CS: string = "centreState";
  static readonly STATE_NS: string = "navigationState";
  static readonly STATE_GS: string = "groupState";
  static readonly STATE_TS: string = "tutorState";
  static readonly STATE_TES: string = "tutorEditState";
  static readonly STATE_TDS: string = "tutorDeleteState";
  static readonly STATE_RS: string = "roleState";
  static readonly STATE_UPS: string = "userProfileState";
  static readonly STATE_CRS: string = "courseState";
  static readonly STATE_CLS: string = "createLearnerState";
  static readonly STATE_LAS: string = "learnerState";
  static readonly STATE_DP: string = "dateProviderState";
  static readonly STATE_ELS: string = "editLearnerState";
  static readonly STATE_ALS: string = "listAdministratorState";
  static readonly STATE_LCS: string = "learnerCourseState";
  static readonly STATE_CCM: string = "courseContentMetadataState";
  static readonly STATE_LT: string = "learningTrackingState";
  static readonly STATE_EGS: string = "editGroupState";
  static readonly STATE_LOA: string = "learnerOfflineActivityState";
  static readonly STATE_LRA: string = "learningResourcesState";
  static readonly STATE_CO: string = "contentObjectsState";
  static readonly STATE_EIA: string = "externalInitialAssessmentState";
  static readonly STATE_AP: string = "assessmentProfileState";
  static readonly STATE_LRRA: string = "learnerResourcesState";
  static readonly STATE_TLS: string = "transferLearnerState";
  static readonly STATE_EH: string = "eventHistoryState";
  static readonly STATE_DLSA: string = "digLitSelfAssessmentState";
  static readonly STATE_RMS: string = "resetMFAState";
  static readonly STATE_LRAS: string = "learnerReportState";
  static readonly STATE_WAR: string = "writtenAssignmentRecordState";
  static readonly STATE_IS: string = "importState";
  static readonly STATE_IERS: string = "importExternalResultsState";
  static readonly STATE_BDD: string = "importBatchDisableDeleteState"
  static readonly STATE_ARS: string = "aggregateReportsState";
  static readonly STATE_PRT: string = "printState";
  static readonly INITIAL_STATE: StoreState = {
    courseId: 0,
    learningRecordTabState: initialLearningRecordTabState,
    skillsCheckTabState: initialSkillsCheckState,
    editAdministratorState: initialEditAdministratorState,
    formAdministratorState: initialFormAdministratorState,
    learningPlanState: initialLearningPlanState,
    skillsCheckQandAState: initialSkillsCheckQandAState,
    organisationState: initialOrganisationState,
    centreState: initialCentreState,
    navigationState: initialNavigationState,
    groupState: initialGroupState,
    tutorState: initialTutorState,
    tutorEditState: initialTutorEditState,
    tutorDeleteState: initialTutorDeleteState,
    roleState: initializeRoleState,
    userProfileState: initializeUserProfileState,
    courseState: initialCourseState,
    createLearnerState: initialCreateLearnerState,
    learnerState: initialLearnerState,
    dateProviderState: initialDateProviderState,
    editGroupState: initialEditGroupState,
    editLearnerState: initialEditLearnerState,
    listAdministratorState: initialListAdministratorState,
    learnerCourseState: initialLearnerCourseState,
    courseContentMetadataState: initialCourseContentMetadataState,
    learningTrackingState: initialLearningTrackingState,
    learnerOfflineActivityState: initialLearnerOfflineActivityState,
    learningResourcesState: initialLearningResourceState,
    externalInitialAssessmentState: initialExternalInitialAssessmentState,
    assessmentProfileState: initialAssessmentProfileState,
    learnerResourcesState: initialLearnerResourceState,
    transferLearnerState: initialTransferLearnerState,
    eventHistoryState: initialEventHistoryState,
    digLitSelfAssessmentState: initialDigLitSelfAssessmentState,
    resetMFAState: initialResetMFAState,
    learnerReportState: initialLearnerReportState,
    writtenAssignmentRecordState: initialWrittenAssignmentRecordState,
    importState: initialImportState,
    importExternalResultsState: initialImportExternalResultsState,
    importBatchDisableDeleteState : initialImportBatchDisableDeleteState,
    aggregateReportsState: initialAggregateReportState,
    printState: initialPrintState
  };
}

export const enum LearningRecordTabActionTypes {
  SetSelectedCourse = "[LRT] Set selected course",
  SetSelectedCourseSuccess = "[LRT] Set selected course: Success",
  SetTabState = "[LRT] Set tab state: Start",
  SetTabStateSuccess = "[LRT] Set tab state: Success",
  UpdateTabState = "[LRT] Update tab state: Start",
  UpdateTabStateSuccess = "[LRT] Update tab state: Success",
  GetLearningRecord = "[LRT] Get learning record: Start",
  GetLearningRecordSucess = "[LRT] Get learning record: Success",
  GetLearningRecordError = "[LRT] Get learning record: Error",
  GetLearningRecordByLearnerId = "[LRT] Get learning by learner id: Start",
  ResetPanelState = "[LRT] Reset panel state"
}

export const enum SkillsCheckTabActionTypes {
  IsSkillsCheckEnabled = "[SCT] Check skills check enabled: Start",
  IsSkillsCheckEnabledSuccess = "[SCT] Check skills check enabled: Success",
  IsSkillsCheckEnabledError = "[SCT] Check skills check enabled: Error",
  GetSkillsCheckResult = "[SCT] Get skills check result: Start",
  GetSkillsCheckResultByLearnerId = "[SCT] Get skills check result by learner id: Start",
  GetSkillsCheckResultSuccess = "[SCT] Get skills check result: Success",
  GetSkillsCheckResultError = "[SCT] Get skills check result: Error",
  UpdatePanelState = "[SCT] Update panel state",
  UpdatePanelStateSuccess = "[SCT] Update panel state: Success",
  UpdateSkillsCheckPanelState = "[SCT] Update skills check state",
  UpdateAttemptPanelState = "[SCAT] Update attempt panel state",
  UpdateAttemptPanelStateSuccess = "[SCAT] Update attempt panel state: Success",
  IsSkillsCheckEnabledByLearnerId = "[SCT] Check skills check enabled by learner id: Start",
  ResetSkillsCheckState = "[SCT] Reset skills check state",
}

export const enum StoreActionTypes {
  ClearState = "[SAT] Clear state",
  SetCourseId = "[SAT] Set Course Id",
  SessionState = "[SAT] Retrieve Session State",
}

export enum FormAdministratorActionTypes {
  CreateAdmin = "[FA] Create admin: Start",
  CreateAdminSuccess = "[FA] Create admin: Success",
  CreateAdminError = "[FA] Create admin: Error",
  ClearFormAdminstratorState = "[FA] Clear State",
}

export enum EditAdministratorActionTypes {
  GetAdmin = "[EA] Get admin: start",
  GetAdminSuccess = "[EA] Get admin: Success",
  GetAdminError = "[EA] Get admin: Error",
  EditAdmin = "[EA] Edit admin: Start",
  EditAdminSuccess = "[EA] Create admin: Success",
  EditAdminError = "[EA] Create admin: Error",
  ClearEditAdministratorState = "[EA] Clear State",
}

export const enum LearningPlanActionTypes {
  SetSelectedCourse = "[LP] Set selected course",
  SetSelectedCourseSuccess = "[LP] Set selected course: Success",
  SetPanelState = "[LP] Set panel state: Start",
  SetPanelStateSuccess = "[LP] Set panel state: Success",
  UpdatePanelState = "[LP] Update panel state: Start",
  UpdatePanelStateSuccess = "[LP] Update panel state: Success",
  UpdateAllowPopUpStart = "[LP] Update Allow popup: Start",
  UpdateAllowPopUpSuccess = "[LP] Update Allow popup: Success",
  UpdatePopUpReminder = "[LP] Update Popup Reminder",
  GetLearningPlan = "[LP] Get Learning plan: Start",
  GetLearningPlanSuccess = "[LP] Get Learning plan: Success",
  GetLearningPlanError = "[LP] Get Learning plan: Error",
  GetManualLearningPlan = "[LP] Get Manual Learning plan: Start",
  GetManualLearningPlanSuccess = "[LP] Get Manual Learning plan: Success",
  GetManualLearningPlanError = "[LP] Get Manual Learning plan: Error",
  SaveManualLearningPlan = "[LP] Save Manual Learning plan: Start",
  SaveManualLearningPlanSuccess = "[LP] Save Manual Learning plan: Success",
  SaveManualLearningPlanError = "[LP] Save Manual Learning plan: Error",
  AssignSkillsCheckContent = "[LP] Assign Skills Check Content: Start",
  AssignSkillsCheckContentSuccess = "[LP] Assign Skills Check Content: Success",
  AssignSkillsCheckContentError = "[LP] Assign Skills Check Content: Error",
  SetActiveActivity = "[LP] Set active activity",
  GetLearnerLearningPlan = "[LP] Get learner learning plan: Start",
  GetLearnerLearningPlanSuccess = "[LP] Get learner learning plan: Success",
  GetLearnerLearningPlanError = "[LP] Get learner learning plan: Error",
  ResetLearingPlan = "[LP] Reset learning plan",
  GenerateLearningPlan = "[LP] Generate learning plan: Start",
  EditLearningPlan = "[LP] Edit learning plan: Start",
  EditLearningPlanSuccess = "[LP] Edit learning plan: Success",
  EditLearningPlanError = "[LP] Edit learning plan: Error",
  ResetEditLearingPlan = "[LP] Reset edit learning plan",
  UpdateWrittenAssignment = "[LP] Update Written Assignment",
  UpdateCategoryOnCurrentLevelChange = "[LP] Update Category On Current Level Change",
  GetCategoryOnCurrentLevelChangeSuccess = "[LP] Get Category On Current Level Change: Success",
}

export const enum SkillsCheckQandAActionTypes {
  SetState = "[SCQAT] Set state: Start",
  SetStateSuccess = "[SCQAT] Set state: Success",
}

export const enum OrganisationActionTypes {
  GetOrganisationList = "[OS] Get list: Start",
  GetOrganisationListSuccess = "[OS] Get list: Success",
  GetOrganisationListError = "[OS] Get list: Error",
  UpdateOrganisationTable = "[OS] Update Organisation Table: Start",
  UpdateOrganisationTableSuccess = "[OS] Update Organisation Table: Success",
  UpdateOrganisationTableError = "[OS] Update Organisation Table: Start: Error",
  GetOrganisationTable = "[OS] Get Organisation Table: Start",
  GetOrganisationTableSuccess = "[OS] Get Organisation Table: Success",
  GetOrganisationTableError = "[OS] Get Organisation Table: Error",
  GetOrganisationTableLength = "[OS] Get Organisation Table Length: Start",
  GetOrganisationTableLengthSuccess = "[OS] Get Organisation Table Length: Success",
  GetOrganisationTableLengthError = "[OS] Get Organisation Table Length: Error",
  ResetOrganisationTable = "[OS] Reset Organisation Table: Start",
  ResetOrganisationTableSuccess = "[OS] Reset Organisation Table: Success",
  ResetOrganisationTableError = "[OS] Reset Organisation Table: Error",
  CreateOrganisation = "[OS] Create organisation: Start",
  CreateOrganisationSuccess = "[OS] Create organisation: Success",
  CreateOrganisationError = "[OS] Create organisation: Error",
  IsAvailableOrgName = "[OS] Is Available org name: Start",
  IsAvailableOrgNameSuccess = "[OS] Is Available org name: Success",
  IsAvailableOrgNameInvalid = "[OS] Is Available org name: Invalid",
  IsAvailableOrgNameError = "[OS] Is Available org name: Error",
  ClearCrudOrganisationState = "[OS] Clear crud organisation state",
  ClearEditOrganisationState = "[OS] Clear edit organisation state",
  ClearAvailability = "[OS] Clear availability",
  GetOrganisationDetails = "[OS] Get Organisation Details: Start",
  GetOrganisationDetailsSuccess = "[OS] Get Organisation Details: Success",
  GetOrganisationDetailsError = "[OS] Get Organisation Details: Error",
  SetOrganisationDetails = "[OS] Set Organisation Details: Start",
  EditOrganisation = "[OS] Edit organisation: Start",
  EditOrganisationSuccess = "[OS] Edit organisation: Success",
  EditOrganisationError = "[OS] Edit organisation: Error",
  GetOrganisationPermission = "[OS] Get Organisation Permission: Start",
  GetOrganisationPermissionSuccess = "[OS] Get Organisation Permission: Success",
  GetOrganisationPermissionError = "[OS] Get Organisation Permission: Error",
  RemoveItemsFromOrganisationList = "[OS] Remove items from organisation list: Start",
  GetIsOrganisationDeletable = "[OS] Get is organisation deletable: Start",
  GetIsOrganisationDeletableSuccess = "[OS] Get is organisation deletable: Success",
  GetIsOrganisationDeletableError = "[OS] Get is organisation deletable: Error",
  DeleteOrganisation = "[OS] Delete organisation: Start",
  DeleteOrganisationSuccess = "[OS] Delete organisation: Success",
  DeleteOrganisationError = "[OS] Delete organisation: Error",
  ResetOrganisationState = "[OS] Reset organisation state"
}

export const enum CentreActionTypes {
  CheckIsValidCentreName = "[CS] Check valid centre name: Start",
  CheckIsValidCentreNameSuccess = "[CS] Check valid centre name: Success",
  CheckIsValidCentreNameError = "[CS] Check valid centre name: Error",
  AddCentre = "[CS] Add centre: Start",
  AddCentreSuccess = "[CS] Add centre: Success",
  AddCentreError = "[CS] Add centre: Error",
  ClearCentreState = "[CS] Clear centre state",
  ClearCrudCentreState = "[CS] Clear crud state",
  UpdateCentreTable = "[CS] Update centre list: Start",
  UpdateCentreTableSuccess = "[CS] Update centre list: Success",
  UpdateCentreTableError = "[CS] Update centre list: Error",
  GetCentreTable = "[CS] Get centre list: Start",
  GetCentreTableSuccess = "[CS] Get centre list: Success",
  GetCentreTableError = "[CS] Get centre list: Error",
  GetCentreTableLength = "[CS] Get centre list length: Start",
  GetCentreTableLengthSuccess = "[CS] Get centre list length: Success",
  GetCentreTableLengthError = "[CS] Get centre list length: Error",
  GetCentresByOrgId = "[CS] Get centres by organisation id: Start",
  GetCentresByOrgIdSuccess = "[CS] Get centres by organisation id: Success",
  GetCentresByOrgIdError = "[CS] Get centres by organisation id: Error",
  GetCentresByUserIdAndOrgId = "[CS] Get centre by userprofile id and organisation id: Start",
  GetCentresByUserIdAndOrgIdSuccess = "[CS] Get centre by userprofile id and organisation id: Success",
  GetCentresByUserIdAndOrgIdError = "[CS] Get centre by userprofile id and organisation id: Error",
  ResetCentresByOrgIdList = "[CS] Reset centres by organisation id list",
  ResetCentreTable = "[CS] Reset centre list: Start",
  ResetCentreTableSuccess = "[CS] Reset centre list: Success",
  ResetCentreTableError = "[CS] Reset centre list: Error",
  ResetCentreTableUnload = "[CS] Unload scenario reset centre list: Start",
  UpdateCentre = "[CS] Update Centre: Start",
  UpdateCentreSuccess = "[CS] Update Centre: Success",
  UpdateCentreError = "[CS] Update Centre: Error",
  SetCentreData = "[CS] Set Centre data",
  SetCentreDataSuccess = "[CS] Set centre data: Success",
  GetCentreData = "[CS] Get Centre data: Start",
  GetAllCentre = "[CS] Get all centre: Start",
  GetAllCentreSuccess = "[CS] Get all centre: Success",
  GetAllCentreError = "[CS] Get all centre: Error",
  ValidateDeleteCentre = "[GS] Validate delete centre: Start",
  ValidateDeleteCentreSuccess = "[GS] Validate delete centre: Success",
  ValidateDeleteCentreError = "[GS] Validate delete centre: Error",
  DeleteCentre = "[GS] Delete centre: Start",
  DeleteCentreSuccess = "[GS] Delete centre: Success",
  DeleteCentreError = "[GS] Delete centre: Error",
  ResetDeleteCentre = "[GS] Reset Delete Centre",
  GetAllCentresByOrgIds = "[CS] Get all centres by sets of organisation id: Start",
  GetAllCentresByOrgIdsSuccess = "[CS] Get all centres by sets of organisation id: Success",
  GetAllCentresByOrgIdsError = "[CS] Get all centres by sets of organisation id: Error",
  GetAllCentresByOrgIdsTutorFlow = "[CS] Get all centres by sets of organisation id tutor flow: Start",
  GetAllCentresByOrgIdsTutorFlowSuccess = "[CS] Get all centres by sets of organisation id tutor flow: Success",
  GetAllCentresByOrgIdsTutorFlowError = "[CS] Get all centres by sets of organisation id tutor flow: Error",
  ResetAllCentresByOrgIds = "[CS] Reset all centres by sets of organisation id",
}

export const enum NavigationStateActionTypes {
  SetHasDirtyForm = "[NS] Set hasDirtyForm",
  SetCurrentRoute = "[NS] Set currentRoute",
  TriggerNavigation = "[NS] Trigger navigation",
  ClearTriggerNavigation = "[NS] Clear trigger navigation",
  AllowUnload = "[NS] Allow unload",
  StoreNavigationSession = "[NS] Save navigation session state",
}

export const enum GroupActionTypes {
  AddGroup = "[GS] Add group: Start",
  AddGroupSuccess = "[GS] Add group: Success",
  AddGroupError = "[GS] Add group: Error",
  ResetGroupState = "[GS] Reset group state",
  SetGroupTablePage = "[GS] Set Group table page",
  GetGroupTable = "[GS] Get Group table: Start",
  GetGroupTableSuccess = "[GS] Get Group table: Success",
  GetGroupTableError = "[GS] Get Group table: Error",
  GetGroupTableLength = "[GS] Get Group table length: Start",
  GetGroupTableLengthSuccess = "[GS] Get Group table length: Success",
  GetGroupTableLengthError = "[GS] Get Group table length: Error",
  UpdateGroupTable = "[GS] Update Group table list: Start",
  UpdateGroupTableSuccess = "[GS] Update Group table list: Success",
  UpdateGroupTableError = "[GS] Update Group table list: Error",
  GetOrgCentreGroupList = "[GS] Get org centre group list: Start",
  GetOrgCentreGroupListSuccess = "[GS] Get org centre group list: Success",
  GetOrgCentreGroupListError = "[GS] Get org centre group list: Error",
  ResetOrgCentreGroupList = "[GS] Reset org centre group list",
  DeleteGroups = "[GS] Delete groups: Start",
  DeleteGroupsSuccess = "[GS] Delete groups: Success",
  DeleteGroupsError = "[GS] Delete groups: Error",
  GetCurrentPageNumber = "[GS] Get current page number: Start",
  GetCurrentPageNumberSuccess = "[GS] Get current page number: Success",
  GetCurrentPageNumberError = "[GS] Get current page number: Error",
  ProcessGetLearnerIdsToAssign = "[GS] Process Get Learner Ids To Assign: start",
  ProcessGetLearnerIdsToAssignSuccess = "[GS] Process Get Learner Ids To Assign: success",
  ProcessGetLearnerIdsToAssignError = "[GS] Process Get Learner Ids To Assign: error",
  GetGroupByOrgOptionalCentre = "[GS] Get group list by organisation Id with or without centre ids: Start",
  GetGroupByOrgOptionalCentreSuccess = "[GS] Get group list by organisation Id with or without centre ids: Success",
  GetGroupByOrgOptionalCentreError = "[GS] Get group list by organisation Id with or without centre ids: Error",
  GetGroupByOrgOptionalCentreTutorFlow = "[GS] Get group list by organisation Id with or without centre ids tutor flow: Start",
  GetGroupByOrgOptionalCentreTutorFlowSuccess = "[GS] Get group list by organisation Id with or without centre ids tutor flow: Success",
  GetGroupByOrgOptionalCentreTutorFlowError = "[GS] Get group list by organisation Id with or without centre ids tutor flow: Error",
}

export const enum TutorActionTypes {
  AddTutor = "[TS] Add tutor: Start",
  AddTutorError = "[TS] Add tutor: Error",
  AddTutorSuccess = "[TS] Add tutor: Success",
  ResetTutorState = "[TS] Reset tutor state",
  GetTutorTable = "[TS] Get tutor list: Start",
  GetTutorTableSuccess = "[TS] Get tutor list: Success",
  GetTutorTableError = "[TS] Get tutor list: Error",
  GetTutorTableLength = "[TS] Get tutor list length: Start",
  GetTutorTableLengthSuccess = "[TS] Get tutor list length: Success",
  GetTutorTableLengthError = "[TS] Get tutor list length: Error",
  UpdateTutorTable = "[TS] Update tutor list: Start",
  UpdateTutorTableSuccess = "[TS] Update tutor list: Success",
  UpdateTutorTableError = "[TS] Update tutor list: Error",
  ResetTutorTable = "[TS] Reset tutor list",
  ResetTutorTableSuccess = "[TS] Reset tutor list: Success",
  ResetTutorTableError = "[TS] Reset tutor list: Error",
  ResetTutorCrud = "[TS] Reset tutor crud",
  GetTutorUserProfile = "[UPS] Get tutor user profile: Start",
  GetTutorUserProfileSuccess = "[UPS] Get tutor user profile: Success",
  GetTutorUserProfileError = "[UPS] Get tutor user profile: Error",
  UpdateTutorGroupTable = "[TS] Update tutor group list: Start",
  GetGroupTutorCount = "[TS] Get group tutor count: Start",
  GetGroupTutorCountSuccess = "[TS] Get group tutor count: Success",
  GetGroupTutorCountError = "[TS] Get group tutor count: Error",
  TutorHasAccessToLearner = "[TS] Get tutor has access to learner: Start",
  TutorHasAccessToLearnerSuccess = "[TS] Get tutor has access to learner: Success",
  TutorHasAccessToLearnerError = "[TS] Get tutor has access to learner: Error",
  GetCurrentPageNumber = "[TS] Get current page number",
  GetCurrentPageNumberSuccess = "[TS] Get current page number: Success",
  GetCurrentPageNumberError = "[TS] Get current page number: Error",
  UpdateTutorAccountStatus = "[TS] Update Tutor Account Status",
  UpdateTutorAccountStatusSuccess = "[TS] Update Tutor Account Status: Success",
  UpdateTutorAccountStatusError = "[TS] Update Tutor Account Status: Error",
  ResetUpdateTutorAccountStatusProps = "[TS] Reset Update Tutor Account Status Props",
}

export const enum TutorEditActionTypes {
  SetTutorProfile = "[TES] Set tutor profile",
  SetTutorProfileSuccess = "[TES] Set tutor profile: Success",
  IsTutorProfileStored = "[TES] Is tutor profile stored",
  LoadTutorProfileSuccess = "[TES] Load tutor profile: Success",
  GetIfAllowedToEditTutor = "[TES] Get if current user allowed to edit tutor: Start",
  GetIfAllowedToEditTutorSuccess = "[TES] Get if current user allowed to edit tutor: Success",
  GetIfAllowedToEditTutorError = "[TES] Get if current user allowed to edit tutor: Error",
  ResetCheckIfAllowedToEditTutor = "[TES] Reset Check if current user allowed to edit tutor",
  UpdateTutor = "[TES] Update tutor: Start",
  UpdateTutorError = "[TES] Update tutor: Error",
  UpdateTutorSuccess = "[TES] Update tutor: Success",
  ResetTutorUpdateProps = "[TES] Reset tutor update properties",
}

export const enum TutorDeleteActionTypes {
  DeleteTutor = "[TDS] Delete tutor: Start",
  DeleteTutorError = "[TDS] Delete tutor: Error",
  DeleteTutorSuccess = "[TDS] Delete tutor: Success",
  ResetDeleteTutorProps= "[TDS] Reset delete tutor props",
}

export const enum RoleActionTypes {
  GetAdministratorRoles = "[RS] Get Administrator Roles",
  GetAdministratorRolesSuccess = "[RS] Get Administrator Roles Success",
  GetAdministratorRolesError = "[RS] Get Administrator Roles Error",
}

export const enum UserProfileActionTypes {
  GetOwnUserProfile = "[UPS] Get Own User Profile",
  GetOwnUserProfileSuccess = "[UPS] Get Own User Profile Success",
  GetOwnUserProfileError = "[UPS] Get Own User Profile Error",
  ResetOwnUserProfile = "[UPS] Reset Own User Profile",
  GetUserProfile = "[UPS] Get User Profile: Start",
  GetUserProfileSuccess = "[UPS] Get User Profile: Success",
  GetUserProfileError = "[UPS] Get User Profile: Error",
  UserHasAccessToLearner = "[UPS] Get User has access to learner: Start",
  UserHasAccessToLearnerSuccess = "[UPS] Get User has access to learner: Success",
  UserHasAccessToLearnerError = "[UPS] Get User has access to learner: Error",
  SetUserProfile = "[UPS] Set User Profile",
}

export const enum CourseActionTypes {
  GetCourses = "[CRS] Get list: Start",
  GetCoursesSuccess = "[CRS] Get list: Success",
  GetCoursesError = "[CRS] Get list: Error",
  GetCourseById = "[CRS] Get course by id: Start",
  GetCourseByIdSuccess = "[CRS] Get course by id: Success",
  GetCourseByIdError = "[CRS] Get course by id: Error",
  GetCategoriesByCourseId = "[CRS] Get categories by courseid: Start",
  GetCategoriesByCourseIdSuccess = "[CRS] Get categories by courseid: Success",
  GetCategoriesByCourseIdError = "[CRS] Get categories by courseid: Error"  
}

export const enum CreateLearnerActionTypes {
  SetLearner = "[CLS] Set learner details",
  CreateLearner = "[CLS] Create learner: Start",
  CreateLearnerSuccess = "[CLS] Create learner: Success",
  CreateLearnerError = "[CLS] Create learner: Error",
  AddGroup = "[CLS] Add group",
  ResetGroupList = "[CLS] Reset group list",
  ResetCreateLearnerState = "[CLS] Reset create learner state",
  AddLearnerCourse = "[CLS] Add learner course",
}

export const enum LearnerActionTypes {
  ResetLearnerState = "[LAS] Reset learner state",
  GetLearnerTable = "[LAS] Get learner table: Start",
  GetLearnerTableSuccess = "[LAS] Get learner table: Success",
  GetLearnerTableError = "[LAS] Get learner table: Error",
  GetLearnerTableLength = "[LAS] Get learner table length: Start",
  GetLearnerTableLengthSuccess = "[LAS] Get learner table length: Success",
  GetLearnerTableLengthError = "[LAS] Get learner table length: Error",
  UpdateLearnerTable = "[LAS] Update learner table: Start",
  UpdateLearnerTableSuccess = "[LAS] Update learner table: Success",
  UpdateLearnerTableError = "[LAS] Update learner table: Error",
  ResetLearnerTable = "[LAS] Reset learner table: Start",
  ResetLearnerTableSuccess = "[LAS] Reset learner table: Success",
  ResetLearnerTableError = "[LAS] Reset learner table: Error",
  UpdateStatus = "[LAS] Update learner status",
  UpdateStatusSuccess = "[LAS] Update learner status: Success",
  UpdateStatusError = "[LAS]  Update learner status: Error",
  GetCurrentPageNumber = "[LAS] Get current page number",
  GetCurrentPageNumberSuccess = "[LAS] Get current page number: Success",
  GetCurrentPageNumberError = "[LAS] Get current page number: Error",
  GetGroupLearnerCount = "[LAS] Get group learner count: Start",
  GetGroupLearnerCountSuccess = "[LAS] Get group learner count: Success",
  GetGroupLearnerCountError = "[LAS] Get group learner count: Error",
  DeleteLearners = "[LAS] Delete learners",
  DeleteLearnersSuccess = "[LAS] Delete learners: Success",
  DeleteLearnersError = "[LAS] Delete learners: Error",
  SetMultipleLearnerIds = "[LAS] Set multiple learner ids: Start",
  SetMultipleLearnerIdsSuccess = "[LAS] Set multiple learner ids: Success",
}

export const enum DateProviderActionTypes {
  GetDateProvider = "[DPS] Get Date Provider: Start",
  GetDateProviderSuccess = "[DPS] Get Date Provider: Success",
  GetDateProviderError = "[DPS] Get Date Provider: Error",
}

export const enum AdministratorListActionTypes {
  ResetAdministratorState = "[ALS] Reset Administrator List state",
  GetAdministratorListTable = "[ALS] Get administrator list: Start",
  GetAdministratorListTableSuccess = "[ALS] Get administrator list: Success",
  GetAdministratorListTableError = "[ALS] Get administrator list: Error",
  GetAdministratorTableLength = "[ALS] Get administrator list length: Start",
  GetAdministratorTableLengthSuccess = "[ALS] Get administrator list length: Success",
  GetAdministratorTableLengthError = "[ALS] Get administrator list length: Error",
  UpdateAdministratorTable = "[ALS] Update administrator list: Start",
  UpdateAdministratorTableSuccess = "[ALS] Update administrator list: Success",
  UpdateAdministratorTableError = "[ALS] Update administrator list: Error",
  ResetAdministratorTable = "[ALS] Reset administrator list",
  ResetAdministratorTableSuccess = "[ALS] Reset administrator list: Success",
  ResetAdministratorTableError = "[ALS] Reset administrator list: Error",
  DeleteAdministrators = "[ALS] Delete administrators",
  DeleteAdministratorsSuccess = "[ALS] Delete administrators Success",
  DeleteAdministratorsError = "[ALS] Delete administrators Error",
  ResetAdministratorCrudProperties = "[ALS] Reset Administrator Crud Properties",
  UpdateAdminAccountStatus = "[ALS] Update Admin Account Status",
  UpdateAdminAccountStatusSuccess = "[ALS] Update Admin Account Status: Success",
  UpdateAdminAccountStatusError = "[ALS] Update Admin Account Status: Error",
  ResetUpdateAdminAccountStatusProps = "[ALS] Reset Update Admin Account Status Props",
}

export const enum EditLearnerActionTypes {
  EditLearner = "[ELS] Edit learner: start",
  EditLearnerSuccess = "[ELS] Edit learner: success",
  EditLearnerError = "[ELS] Edit learner: error",
  SetEditLearner = "[ELS] Set learner",
  SetEditLearnerSuccess = "[ELS] Set learner: success",
  LoadLearnerData = "[ELS] Load learner data",
  LoadLearnerDataSuccess = "[ELS] Load learner data: success"
}

export const enum EditGroupStateActionTypes {
  SetEditGroup = "[EGS] Set edit group data: Start",
  SetEditGroupSuccess = "[EGS] Set edit group data: Success",
  SetEditGroupError = "[EGS] Set edit group data: Error",
  EditGroup = "[EGS] Edit group: Start",
  EditGroupSuccess = "[EGS] Edit group: Success",
  EditGroupError = "[EGS] Edit group: Error",
  ResetEditGroup = "[EGS] Edit Reset",
  ReloadEditGroup = "[EGS] Reload edit group: Start",
}

export const enum LearnerCourseActionTypes {
  ResetLearnerCourseState = "[LCS] Reset Learner Course State",
  GetLearnerCoursesList = "[LCS] Get Learner Courses: start",
  GetLearnerCoursesListSuccess = "[LCS] Get Learner Courses: success",
  GetLearnerCoursesListError = "[LCS] Get Learner Courses: error",
  UpdateDisableLearnerCourse = "[LCS] Update Disable Learner Course: start",
  UpdateDisableLearnerCourseSuccess = "[LCS] Update Disable Leaner Course: success",
  UpdateDisableLearnerCourseError = "[LCS] Update Disable Learner Course: error",
  ReAssignLearnerToAssessment = "[LCS] Re-Assign Learner to Assessment: Start",
  ReAssignLearnerToAssessmentSuccess = "[LCS] Re-Assign Learner to Assessment: Success",
  ReAssignLearnerToAssessmentError = "[LCS] Re-Assign Learner to Assessment: Error",
  GenerateLearningPlan = "[LCS] Generate Learning Plan: Start",
  GenerateLearningPlanSuccess = "[LCS] Generate Learning Plan: Success",
  GenerateLearningPlanError = "[LCS] Generate Learning Plan: Error",
  GetLearnersLearnerCourseLogStatus = "[LCS] Get Learners Learner course log status: Start",
  GetLearnersLearnerCourseLogStatusSuccess = "[LCS] Get Learners Learner course log status: Success",
  GetLearnersLearnerCourseLogStatusError = "[LCS] Get Learners Learner course log status: Error",
  GetLearnerCourseLog = "[LCS] Get Learner course log: Start",
  GetLearnerCourseLogSuccess = "[LCS] Get Learner course log: Success",
  GetLearnerCourseLogError = "[LCS] Get Learner course log: Error",
  GetLearnerCourse = "[LCS] Get Learner Course: start",
  GetLearnerCourseSuccess = "[LCS] Get Learner Course: success",
  GetLearnerCourseError = "[LCS] Get Learner Course: error",
  UpdateLearnerCourse = "[LCS] Update Learner Course: start",
  UpdateLearnerCourseSuccess = "[LCS] Update Leaner Course: success",
  UpdateLearnerCourseError = "[LCS] Update Learner Course: error",
  AddLearnerCourseList = "[LCS] Add Learner Course List: start",
  AddLearnerCourseListSuccess = "[LCS] Add Leaner Course List: success",
  AddLearnerCourseListError = "[LCS] Add Leaner Course List: error",
  ResetAddLearnerCourseList = "[LCS] Reset Add Leaner Course List",
  GetLearnerCourseScreenerResult = "[LCS] Get Learner Course with Screener Result: Start",
  GetLearnerCourseScreenerSuccess = "[LCS] Get Learner Course with Screener Result: Success",
  GetLearnerCourseScreenerError = "[LCS] Get Learner Course with Screener Result: Error"
}

export const enum CourseContentMetadataActionTypes {
  GetActivityDetails = "[CCM] Get activity details: Start",
  GetActivityDetailsSuccess = "[CCM] Get activity details: Success",
  GetActivityDetailsError = "[CCM] Get activity details: Error",
  GetResourceDetails = "[CCM] Get resource details: Start",
  GetResourceDetailsSuccess = "[CCM] Get resource details: Success",
  GetResourceDetailsError = "[CCM] Get resource details: Error",
}

export const enum LearningTrackingActionTypes {
  IsEnableLearningTab = "[LT] Is enable learning tab: Start",
  IsEnableLearningTabSuccess = "[LT] Is enable learning tab: Success",
  IsEnableLearningTabError = "[LT] Is enable learning tab: Error",
}

export const enum LearnerOfflineActivityTypes {
  AddLearnerOfflineActivity = "[LOA] Add Learner Offline Activity: Start",
  AddLearnerOfflineActivitySuccess = "[LOA] Add Learner Offline Activity: Success",
  AddLearnerOfflineActivityError = "[LOA] Add Learner Offline Activity: Error",
  ResetAddLearnerOfflineActivityResult = "[LOA] Reset Add Learner Offline Activity Result",
  EditLearnerOfflineActivity = "[LOA] Edit Learner Offline Activity: Start",
  EditLearnerOfflineActivitySuccess = "[LOA] Edit Learner Offline Activity: Success",
  EditLearnerOfflineActivityError = "[LOA] Edit Learner Offline Activity: Error",
  ResetEditLearnerOfflineActivityResult = "[LOA] Reset Edit Learner Offline Activity Result",
  GetOfflineActivitySkillSelection = "[LOA] Get Offline Activity Skill Selection: Start",
  GetOfflineActivitySkillSelectionSuccess = "[LOA] Get Offline Activity Skill Selection: Success",
  GetOfflineActivitySkillSelectionError = "[LOA] Get Offline Activity Skill Selection: Error",
  GetOfflineActivity = "[LOA] Get Offline Activity: Start",
  GetOfflineActivitySuccess = "[LOA] Get Offline Activity: Success",
  GetOfflineActivityError = "[LOA] Get Offline Activity: Error",
  SetOfflineActivityNavigationRoute = "[LOA] Set Offline Activity Navigation Route",
  StoreOfflineActivityNavigationSession = "[LOA] Save Offline Activity Navigation Session State",
}

export const enum LearningResourceActionTypes {
  ResetLearningResourcesState = "[LRA] Reset Learning Resources State",
  GetLearningResources = "[LRA] Get Learning Resources: Start",
  GetLearningResourcesSuccess = "[LRA] Get Learning Resources: Success",
  GetLearningResourcesError = "[LRA] Get Learning Resources: Error",
  UpdateLearningResources = "[LRA] Update Learning Resources: Start",
  UpdateLearningResourcesSuccess = "[LRA] Update Learning Resources: Success",
  UpdateLearningResourcesError = "[LRA] Update Learning Resources: Error",
  ResetLearningResources = "[LRA] Reset Learning Resources: Start",
  ResetLearningResourcesSuccess = "[LRA] Reset Learning Resources: success",
  UpdateActivityDueDate = "[LRA] Update Activity Due Date: Start",
  UpdateActivityDueDateSuccess = "[LRA] Update Activity Due Date: Success",
  UpdateActivityDueDateError = "[LRA] Update Activity Due Date: Error",
  AddLearningResources = "[LRA] Add Learning Resources: Start",
  AddLearningResourcesSuccess = "[LRA] Add Learning Resources: Success",
  AddLearningResourcesError = "[LRA] Add Learning Resources: Error",
  RemoveLearningResources = "[LRA] Remove Learning Resources: Start",
  RemoveLearningResourcesSuccess = "[LRA] Remove Learning Resources: Success",
  RemoveLearningResourcesError = "[LRA] Remove Learning Resources: Error",
  GetModuleType = "[LRA] Get Module Type: Start",
  GetModuleTypeSuccess = "[LRA] Get Module Type: Success",
  GetLearningResourceItems = "[LRA] Learning Resource Items: Start",
  GetLearningResourceItemsSuccess = "[LRA] Learning Resource Items: Success",
  GetLearningResourceItemsError = "[LRA] Learning Resource Items: Error",
}

export const enum AssessmentProfileActionTypes {
  GetAssessmentProfile = "[AP] Get Assessment Profile: Start",
  GetAssessmentProfileSuccess = "[AP] Get Assessment Profile: Success",
  GetAssessmentProfileError = "[AP] Get Assessment Profile: Error",
  ResetGetAssessmentProfileState = "[AP] Reset Get Assessment Profile State",
}

export const enum ExternalInitialAssessmentActionTypes {
  AddExternalInitialAssessment = "[EIA] Add External Initial Assessment",
  AddExternalInitialAssessmentSuccess = "[EIA] Add External Initial Assessment: Success",
  AddExternalInitialAssessmentError = "[EIA] Add External Initial Assessment: Error",
  ResetExternalInitialAssessmentProperties = "[EIA] Reset External Initial Assessment Properties",
}

export const enum LearnerResourcesActionTypes {
  ResetLearnerResourcesState = "[LRRA] Reset Learner Resources State",
  GetModuleTypesOfResources = "[LRRA] Get Module Types Of Resources: Start",
  GetModuleTypesOfResourcesSuccess = "[LRRA] Get Module Types Of Resources: Success",
  GetModuleTypesOfResourcesError = "[LRRA] Get Module Types Of Resources: Error",
  GetLearnerResources = "[LRRA] Get Learner Resources: Start",
  GetLearnerResourcesSuccess = "[LRRA] Get Learner Resources: Success",
  GetLearnerResourcesError = "[LRRA] Get Learner Resources: Error",
  UpdateLearnerResources = "[LRRA] Update Learner Resources: Start",
  UpdateLearnerResourcesSuccess = "[LRRA] Update Learner Resources: Success",
  UpdateLearnerResourcesError = "[LRRA] Update Learner Resources: Error",
}

export const enum TransferLearnerActionTypes {
  SubmitTransferRequest = "[TLS] Submit Transfer Request: Start",
  SubmitTransferRequestSuccess = "[TLS] Submit Transfer Request: Success",
  SubmitTransferRequestError = "[TLS] Submit Transfer Request: Error",
  GetAssignedOrganisation = "[TLS] Get Assigned Organisation: Start",
  GetAssignedOrganisationSuccess = "[TLS] Get Assigned Organisation: Success",
  GetAssignedOrganisationError = "[TLS] Get Assigned Organisation: Error",
  FindLearnerDetails = "[TLS] Find learner details: Start",
  FindLearnerDetailsSuccess = "[TLS] Find learner details: Success",
  FindLearnerDetailsError = "[TLS] Find learner details: Error",
  ResetTransferLearnerState = "[TLS] Reset transfer learner",
  StartTransfer = "[TLS] Start transfer: Start",
  StartTransferSuccess = "[TLS] Start transfer: Success",
  StartTransferError = "[TLS] Start transfer: Error",
  UndoTransfer = "[TLS] Undo transfer: Start",
  UndoTransferSuccess = "[TLS] Undo transfer: Success",
  UndoTransferError = "[TLS] Undo transfer: Error",
  SubmitTransferCentreRequest = "[TLS] Submit Transfer Centre Request: Start",
  SubmitTransferRequestCentreSuccess = "[TLS] Submit Transfer Centre Request: Success",
  SubmitTransferRequestCentreError = "[TLS] Submit Transfer Centre Request: Error",
}

export const enum EventHistoryActionTypes {
  GetAllEventTypes = "[EH] Get All Event Types: Start",
  GetAllEventTypesSuccess = "[EH] Get All Event Types: Success",
  GetAllEventTypesError = "[EH] Get All Event Types: Error",
  GetEventHistoryRecords = "[EH] Get Event History Records: Start",
  GetEventHistoryRecordsSuccess = "[EH] Get Event History Records: Success",
  GetEventHistoryRecordsError = "[EH] Get Event History Records: Error",
  SaveLoginHistory = "[EH] Save Login History Records: Start",
  SaveLoginHistorySuccess = "[EH] Save Login History Records: Success",
  SaveLoginHistoryError = "[EH] Save Login History Records: Error",
  GetCurrentPageNumber = "[EH] Get Current Page Number: Start",
  GetCurrentPageNumberSuccess = "[EH] Get Current Page Number: Success",
  GetCurrentPageNumberError = "[EH] Get Current Page Number: Error",
  UpdateEventHistoriesTable = "[EH] Update Event Histories Table: Start",
  UpdateEventHistoriesTableSuccess = "[EH] Update Event Histories Table: Success",
  UpdateEventHistoriesTableError = "[EH] Update Event Histories Table: Error",
  GetEventHistoryRecordLength = "[EH] Get Event History Records Length: Start",
  GetEventHistoryRecordLengthSuccess = "[EH] Get Event History Records Length: Success",
  GetEventHistoryRecordLengthError = "[EH] Get Event History Records Length: Error",
}

export const enum DigLitSelfAssessmentActionTypes {
  GetDigLitSelfAssessmentData = "[DLSA] Get Digital Literacy Self Assessment Data: Start",
  GetDigLitSelfAssessmentDataSuccess = "[DLSA] Get Digital Literacy Self Assessment Data: Success",
  GetDigLitSelfAssessmentDataError = "[DLSA] Get Digital Literacy Self Assessment Data: Error",
  SaveDigLitSelfAssessment = "[DLSA] Save Digital Literacy SelfAssessment State: Start",
  SaveDigLitSelfAssessmentSuccess = "[DLSA] Save Digital Literacy SelfAssessment State: Success",
  SaveDigLitSelfAssessmentError = "[DLSA] Save Digital Literacy SelfAssessment State: Error",
  SaveDigLitSelfAssessmentSession = "[DLSA] Save Digital Literacy SelfAssessment Session State: Start",
  SaveDigLitSelfAssessmentSessionSuccess = "[DLSA] Save Digital Literacy SelfAssessment Session: Success",
  SaveDigLitSelfAssessmentSessionError = "[DLSA] Save Digital Literacy SelfAssessment Session: Error",
  SetDigLitState = "[DLSA] Set Digital Literacy State: Start",
  SetDigLitStateSuccess = "[DLSA] Set Digital Literacy State: Success",
  ResetDigLitSelfAssessmentState = "[DLSA] Reset Digital Literacy State"
}

export const enum ResetMFAActionTypes {
  ResetMFA = "[RMS] Reset MFA: Start",
  ResetMFSSuccess = "[RMS] Reset MFA: Success",
  ResetMFAError = "[RMS] Reset MFA: Error",
  HasMFA = "[RMS] Has MFA: Start",
  HasMFASuccess = "[RMS] Has MFA: Success",
  HasMFAError = "[RMS] Has MFA: Error",
  ClearResetMFAState = "[RMS] Clear reset mfa state"
}

export const enum LearnerReportActionTypes {
  ResetReportState = "[LRAT] Reset Reports State",
  GetLearnerReportTypes = "[LRAT] Get Learner Report Types: Start",
  GetLearnerReportTypesSuccess = "[LRAT] Get Learner Report Types: Success",
  GetLearnerReportTypesError = "[LRAT] Get Learner Report Types: Error",
  UpdateReportSessionFilter = "[LRAT] Update Reports Session Filter: Start",
  UpdateReportSessionFilterSuccess = "[LRAT] Update Reports Session Filter: Success",
  UpdateReportSessionFilterError = "[LRAT] Update Reports Session Filter: Error",
  ResetReportSessionFilterState = "[LRAT] Reset Reports Filter State",
  GetReportsFilter = "[LRAT] Get Reports Filter: Start",
  GetReportsFilterSuccess = "[LRAT] Get Reports Filter: Success",
  GetReportsFilterError = "[LRAT] Get Reports Filter: Error",
  GenerateReports = "[LRAT] Generate Reports: Start",
  GenerateReportsSuccess = "[LRAT] Generate Reports: Success",
  GenerateReportsError = "[LRAT] Generate Reports: Error",
  ResetGetReportsFilter = "[LRAT] Reset Get Reports Filter",
  GetReportsTableResult = "[LRAT] Get Reports Table Result: Start",
  GetReportsTableResultSuccess = "[LRAT] Get Reports Table Result: Success",
  GetReportsTableResultError = "[LRAT] Get Reports Table Result: Error",
  GetReportDetails = "[LRAT] Get Report Details: Start",
  GetReportDetailsSuccess = "[LRAT] Get Report Details: Success",
  GetReportDetailsError = "[LRAT] Get Report Details: Error",
  UpdateTableReportByParams = "[LRAT] Update Table Report by Params: Start",
  UpdateTableReportByParamsSuccess = "[LRAT] Update Table Report by Params: Success",
  UpdateTableReportByParamsError = "[LRAT] Update Table Report by Params: Error",
  GetLearnerReportListLength = "[LRAT] Get Learner Reports Table List Length: Start",
  GetLearnerReportListLengthSuccess = "[LRAT] Get Learner Reports Table List Length: Success",
  GetLearnerReportListLengthError = "[LRAT] Get Learner Reports Table List Length: Error",
  GetLearnerReportsChart = "[LRAT] Get Learners Report Chart: Start",
  GetLearnerReportsChartSuccess = "[LRAT] Get Learners Report Chart: Success",
  GetLearnerReportsChartError = "[LRAT] Get Learners Report Chart: Error",
  ResetLearnerReportsChart = "[LRAT] Reset Learners Report Chart",
  ResetLearnerReportTable = "[LRAT] Reset Learner Report Table: Start",
  ResetLearnerReportTableSuccess = "[LRAT] Reset Learner Report Table: Success",
  ResetLearnerReportTableError = "[LRAT] Reset Learner Report Table: Error",
  ExportReportsTable = "[LRAT] Export Reports Table: Start",
  ExportReportsTableSuccess = "[LRAT] Export Reports Table: Success",
  ExportReportsTableError = "[LRAT] Export Reports Table: Error"
}

export const enum WrittenAssigmentsRecordActionTypes {
  GetWrittenAssignmentRecords = "[WAR] Get Written assignment records: Start",
  GetWrittenAssignmentRecordsSuccess = "[WAR] Get Written assignment records: Success",
  GetWrittenAssignmentRecordsError = "[WAR] Get Written assignment records: Error",
  ViewWrittenAssignmentRecords = "[WAR] View Written assignment records: Start",
}

export const enum ImportActionTypes {
  UploadCSV = "[IAT] Upload CSV: Start",
  UploadTutorCSV = "[IAT] Upload Tutor CSV: Start",
  UploadCSVSuccess = "[IAT] Upload CSV: Success",
  UploadCSVError = "[IAT] Upload CSV: Error",
  GetImportStatus = "[IAT] Get Import Status: Start",
  GetImportStatusSuccess = "[IAT] Get Import Status: Success",
  GetImportStatusError = "[IAT] Get Import Status: Error",
  CloseImportStatus = "[IAT] Close Import SSE Connection",
  AuthorizedSSE = "[IAT] Authorize SSE Request: Start",
  AuthorizedSSESuccess = "[IAT] Authorize SSE Request: Success",
  AuthorizedSSEError = "[IAT] Authorize SSE Request: Error",
  ResetImportStatus = "[IAT] Reset Import State",
  DownloadErrorList = "[IAT] Download Error List: Start",
  DownloadErrorTutorList = "[IAT] Download Error Tutor List: Start",
  DownloadErrorListSuccess = "[IAT] Download Error List: Success",
  DownloadErrorListError = "[IAT] Download Error List: Error",
  HasImport = "[IAT] Has Import: Start",
  HasImportTutor = "[IAT] Has Import Tutor: Start",
  HasImportSuccess = "[IAT] Has Import: Success",
  HasImportError = "[IAT] Has Import: Error",
  ClearImportSession = "[IAT] Clear Import Session: Start",
  ClearImportTutorSession = "[IAT] Clear Import Tutor Session: Start",
  ClearImportSessionSuccess = "[IAT] Clear Import Session: Success",
  ClearImportSessionResult = "[IAT] Clear Import Session: Result",
  CancelImport = "[IAT] Cancel Import: Start",
  CancelImportTutor = "[IAT] Cancel Import Tutor: Start",
  CancelImportSuccess = "[IAT] Cancel Import: Success",
  CancelImportError = "[IAT] Cancel Import: Error"
}

export const enum ImportExternalResultsActionTypes {  
  UploadExternalResultsCSV = "[IER] Upload Learner External Results CSV: Start",
  UploadExternalResultsCSVSuccess = "[IER] Upload Learner External Results CSV: Success",
  UploadExternalResultsCSVError = "[IER] Upload Learner External Results CSV: Error",
  GetExternalResultsImportStatus = "[IER] Get External Results Import Status: Start",
  GetExternalResultsImportStatusSuccess = "[IER] Get External Results Import Status: Success",
  GetExternalResultsImportStatusError = "[IER] Get External Results Import Status: Error",
  AuthorizeImportExternalResultsSSE = "[IER] Authorize Import External Results SSE Request: Start",
  AuthorizeImportExternalResultsSSESuccess = "[IER] Authorize Import External Results SSE Request: Success",
  AuthorizeImportExternalResultsSSEError = "[IER] Authorize Import External Results SSE Request: Error",
  HasImportedExternalResults = "[IER] Currently Imported External Results: Start",
  HasImportedExternalResultsSuccess = "[IER] Currently Imported External Results: Success",
  HasImportedExternalResultsError = "[IER] Currently Imported External Results: Error",
  DownloadExternalResultsImportErrorList = "[IER] Donwload External Results Import Error List: Start",
  DownloadExternalResultsImportErrorListSuccess = "[IER] Download Error List: Success",
  DownloadExternalResultsImportErrorListError = "[IER] Download Error List: Error",  
  CancelExternalResultsImport = "[IER] Cancel External Results Import: Start",
  CancelExternalResultsImportSuccess = "[IER] Cancel External Results Import: Success",
  CancelExternalResultsImportError = "[IER] Cancel External Results Import: Error",
  ClearExternalResultsImportSession = "[IER] Clear External Results Import Session: Start",
  ClearExternalResultsImportSessionSuccess = "[IER] Clear External Results Import Session: Success",
  ClearExternalResultsImportSessionResult = "[IER] Clear External Results Import Session: Result",
  CloseImportExternalResultsStatus = "[IER] Close Import External Results SSE Connection",
  ResetExternalResultsImportStatus = "[IER] Reset External Results Import  State",
}

export const enum ImportBatchDisableDeleteActionTypes {  
  UploadBatchDisableDeleteCSV = "[BDD] Upload Learner Batch Disable Delete CSV: Start",
  UploadBatchDisableDeleteCSVSuccess = "[BDD] Upload Learner Batch Disable Delete CSV: Success",
  UploadBatchDisableDeleteCSVError = "[BDD] Upload Learner Batch Disable Delete CSV: Error",
  GetBatchDisableDeleteImportStatus = "[BDD] Get Batch Disable Delete Import Status: Start",
  GetBatchDisableDeleteImportStatusSuccess = "[BDD] Get Batch Disable Delete Import Status: Success",
  GetBatchDisableDeleteImportStatusError = "[BDD] Get Batch Disable Delete Import Status: Error",
  AuthorizeImportBatchDisableDeleteSSE = "[BDD] Authorize Import Batch Disable Delete SSE Request: Start",
  AuthorizeImportBatchDisableDeleteSSESuccess = "[BDD] Authorize Import Batch Disable Delete SSE Request: Success",
  AuthorizeImportBatchDisableDeleteSSEError = "[BDD] Authorize Import Batch Disable Delete SSE Request: Error",
  HasImportedBatchDisableDelete = "[BDD] Currently Imported Batch Disable Delete: Start",
  HasImportedBatchDisableDeleteSuccess = "[BDD] Currently Imported Batch Disable Delete: Success",
  HasImportedBatchDisableDeleteError = "[BDD] Currently Imported Batch Disable Delete: Error",
  DownloadBatchDisableDeleteImportErrorList = "[BDD] Donwload Batch Disable Delete Import Error List: Start",
  DownloadBatchDisableDeleteImportErrorListSuccess = "[BDD] Download Imported Batch Disable Delete Error List: Success",
  DownloadBatchDisableDeleteImportErrorListError = "[BDD] Download Imported Batch Disable Delete Error List: Error",  
  CancelBatchDisableDeleteImport = "[BDD] Cancel Batch Disable Delete Import: Start",
  CancelBatchDisableDeleteImportSuccess = "[BDD] Cancel Batch Disable Delete Import: Success",
  CancelBatchDisableDeleteImportError = "[BDD] Cancel Batch Disable Delete Import: Error",
  ClearBatchDisableDeleteImportSession = "[BDD] Clear Batch Disable Delete Import Session: Start",
  ClearBatchDisableDeleteImportSessionSuccess = "[BDD] Clear Batch Disable Delete Import Session: Success",
  ClearBatchDisableDeleteImportSessionResult = "[BDD] Clear Batch Disable Delete Import Session: Result",
  CloseImportBatchDisableDeleteStatus = "[BDD] Close Import Batch Disable Delete SSE Connection",
  ResetBatchDisableDeleteImportStatus = "[BDD] Reset Batch Disable Delete Import State",
}

export const enum AggregateReportActionTypes {
  GetStatisticsTableLength = "[ARS] Get Statistics Table Length: Start",
  GetStatisticsTableLengthSuccess = "[ARS] Get Statistics Table Length: Success",
  ResetStatisticsTables = "[ARS] Reset Statistics Tables: Start",
  ResetStatisticsTablesSuccess = "[ARS] Reset Statistics Tables: Success",
  ResetStatisticsState = "[ARS] Reset Statistics State"
}

export const enum PrintActionTypes {
  SetPrintScreenerState = "[PAT] Set Print Screener State",
  SetPrintInitialAssessmentState = "[PAT] Set Print Initial Assessment State",
  SetPrintSelfAssessmentState = "[PAT] Set Print Self Assessment State",
  SetPrintQandAState = "[PAT] Set Print Q and A State",
  SetPrintLearnerRecordTabState = "[PAT] Set Print Learner Record Tab State",
  SetPrintSkillsCheckState = "[PAT] Set Print Skills Check State",
  SetPrintSkillsCheckQandAState = "[PAT] Set Print Skills Check Q and A State",
  SetPrintWrittenAssignState = "[PAT] Set Print Written Assignment State",
  SetPrintLoaderState = "[PAT] Set Print Loader State",
  ClearPrintLoaderState = "[PAT] Clear Print Loader State"
}